"use strict";

/***************************
 * common-scripts.js
 * globals, for use in common and unique script documents, are defined in header.jade and scripts.js
 * from http://stackoverflow.com/a/7048295
 ***************************/

$(document).ready(function() {

    /********************
     * Smooth Scrolling
     * add .smooth-scroll to an anchor tag to get this
     * from https://www.abeautifulsite.net/smoothly-scroll-to-an-element-without-a-jquery-plugin-2
     ********************/
    $('a.smooth-scroll[href^="#"]').on('click', function(event) {
        var target = $(this.getAttribute('href'));
        // console.log('target', target);
        if (target.length) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top
            }, 400);
            // add hash to url
            window.location.hash = target[0].id;
        }
    });

    /**
    * logo clicking
    * from aiden's westland test page
    **/
    $('.home-page .logo-wrapper').on('click', function(e) {
        e.preventDefault();
        $("html, body").animate({scrollTop: 0}, 400);
    });

    /***************************
    * Project Social Sharing
    **************************/
    // Set correct href for social sharing, for Orchard CMS
    var pageURL = window.location.href;
    var pageTitle = document.title;
    $('.social-icons a').each(function() {
        // if not pinterest button which has no href
        if(!$(this).hasClass('object-pinterest')) {
            var oldHref = $(this).attr('href'); // get old href
            var newHref = oldHref.replace('#PageURL', pageURL); // replace #PageURL with real one
            // remove site name from title so won't show up in Twitter feed
            var twitterTitle = pageTitle.substring(0, pageTitle.indexOf('|'));
            newHref = newHref.replace('#PageTitle', twitterTitle); // replace #PageTitle with real one
            newHref = encodeURI(newHref); // from https://stackoverflow.com/a/332897/4504073
            $(this).attr('href', newHref); // set url to newHref
        }        
    });

    // new fb setup, from https://developers.facebook.com/docs/javascript/howto/jquery/v2.10
    // $.ajaxSetup({ cache: true });
    // $.getScript('//connect.facebook.net/en_US/sdk.js', function() {
    //     FB.init({
    //         appId: '1979934708929835',
    //         version: 'v2.7' // or v2.1, v2.2, v2.3, ...
    //     });
    //     $('#share-facebook').removeAttr('disabled');
    //     FB.getLoginStatus(updateStatusCallback);
    // });

    // set button
    if ($('#share-facebook')) {
        $('#share-facebook').click(function() {
            FB.ui({
                method: 'share',
                display: 'popup',
                href: pageURL,
            }, function(response) {});
        })
    }


    /********************
     * External links to new tab
     * from https://forum.getkirby.com/t/open-link-in-new-tab-button-for-non-coders/3151/15?u=lukehatfield
     ********************/
    $('a').each(function() {
        if ((this.host !== window.location.host) && (this.host != '')) {
            $(this).attr('target', '_blank');
        }
    });

    // /**
    //  * Kirby Uniform
    //  * CSRF debugging
    //  * from http://kirby-uniform.readthedocs.io/en/latest/answers/?highlight=cache and https://github.com/mzur/kirby-uniform/pull/144
    //  **/
    // var token_request = new XMLHttpRequest();
    // var request_path = 'gettoken';

    // token_request.onreadystatechange = function() {
    //   var token_fields = document.querySelectorAll('form.inquiry-form input[name="csrf_token"]');

    //   if (this.status === 200 && this.readyState === 4) {
    //     var token = JSON.parse(this.response).token;
    //     for(var i = 0; i < token_fields.length; i++) {
    //       token_fields[i].value = token;
    //     }
    //   }
    // };

    // token_request.open('GET', request_path);
    // token_request.send();


    /*********************
    * Thumbnail Project Popup
    * from https://material.io/components/web/catalog/dialogs/
    *********************/
    // var dialog = new mdc.dialog.MDCDialog(document.querySelector('#mdc-dialog'));
    // var $dialog = $('#mdc-dialog');
    // var $dialogTitle = $('#mdc-dialog-project-title');

    // // dialog.listen('MDCDialog:accept', function() {
    // //     console.log('accepted');
    // // })

    // // dialog.listen('MDCDialog:cancel', function() {
    // //     console.log('canceled');
    // // })

    // // set close button
    // // util.createFocusTrapInstance(surfaceEl, acceptButtonEl, focusTrapFactory = require(‘focus-trap’)) => {activate: () => {}, deactivate: () => {}};

    // // when click on thumbnail project
    // // document.querySelector('#default-dialog-activation').addEventListener('click', function (evt) {
    // $('.thumbnail-project').on('click', function (evt) {
    //     evt.preventDefault();
    //     var $this = $(this);

    //     // get project info
    //     var projectData = $this.data('project-data');
    //     var $dialogProjectDirectors = $dialog.find('.dialog-project-directors');
    //     var $dialogProjectInstitutions = $dialog.find('.project-sidebar-item-institutions');
    //     var $dialogProjectLocations = $dialog.find('.project-sidebar-item-locations');
    //     var $dialogProjectCollaboratingOrgs = $dialog.find('.project-sidebar-item-collaborating-orgs');    
    //     // console.log('projectData', projectData);


    //     // var dialogTitle = 'placeholder title';
    //     var dialogTitle = $this.find('.title .er').html();
    //     var dialogColor = $this.data('color');
    //     // Parse the string back into a proper JSON object, from https://stackoverflow.com/q/7322682

    //     // remove any old color, from https://stackoverflow.com/a/5182103
    //     $dialog.removeClass(function (index, className) {
    //         return (className.match (/(^|\s)hover-color-\S+/g) || []).join(' ');
    //     });
        
    //     // set unique info from clicked project
    //     $dialog.addClass('hover-color-' + dialogColor); // set color
        
    //     // hide all and show all relevent data
    //     $.each(projectData, function(index, element) {
    //         // alert(element);
    //         // find target element
    //         var $targetElement = $dialog.find('.project-sidebar-' + index);

    //         // handle website first, so don't lose link later
    //         if(index == 'website') {
    //             // if have data show it
    //             if(element['website-text'] != '') {
    //                 // build link, replacing element for using in next step (html replacement)
    //                 element = '<a href="' + element["website-link"] + '" target="_blank">' + element["website-text"] + '</a>';

    //             } else {
    //                 element = ''; // set to blank so does not show in next step
    //             }
    //         }

    //         // if have data show it
    //         if(element != '') {
    //             $targetElement.show();
    //             // replace content
    //             $targetElement.find('.project-sidebar-content').html(element)
    //         // else hide the data html
    //         } else {
    //             $targetElement.hide();
    //         }
    //     });

    //     // set project info in dialog
    //     $dialogTitle.html(dialogTitle);

    //     // dialog.lastFocusedTarget = evt.target;
    //     dialog.show();
    // })
    
});


/*****
* Get url params
* from https://stackoverflow.com/a/901144
* usage /us?cities=off
*****/
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
